export * from "./signalTransform";

export const menuList = [
  { name: "HOME", value: "/domain-control/Home", icon: "movie" },
  { name: "IVSE", value: "/domain-control/IVSE", icon: "movie" },
  { name: "ICC", value: "/domain-control/ICC", icon: "movie" },
  // { name: "AWS", value: "/domain-control/AWS", icon: "movie" },
  { name: "dTCS", value: "/domain-control/DMC", icon: "movie" },
  // { name: "DUR", value: "/domain-control/DUR", icon: "movie" },
  { name: "DST", value: "/domain-control/DST", icon: "movie" },
  { name: "TAA", value: "/domain-control/TAA", icon: "movie" },
  { name: "CST", value: "/domain-control/CST", icon: "movie" },
  // { name: "BFD", value: "/domain-control/BFD", icon: "movie" },
  // { name: "SbTv", value: "/domain-control/SbTv", icon: "movie" },
  { name: "IFTF", value: "/domain-control/IFTF", icon: "movie" },
  { name: "EMB", value: "/domain-control/ADA", icon: "movie" },
  { name: "MAABS", value: "/domain-control/MAABS", icon: "movie" },
  { name: "HDC", value: "/domain-control/HDC", icon: "movie" },
];

// if (process.env.NODE_ENV === "development") {
//   menuList.push({ name: "IVSE", value: "/domain-control/IVSE", icon: "movie" });
// }
